function u(n) {
  return function(r) {
    return n.apply(null, r);
  };
}
export {
  u as default
};
